(() => {
  const root = document.querySelector('[data-jpc]');
  if (!root) return;

  const panel = root.querySelector('[data-jpc-panel]');
  const openButton = root.querySelector('[data-jpc-open]');
  const closeButton = root.querySelector('[data-jpc-close]');
  const thread = root.querySelector('[data-jpc-thread]');
  const question = root.querySelector('[data-jpc-question]');
  const options = root.querySelector('[data-jpc-options]');
  const form = root.querySelector('[data-jpc-form]');
  const field = root.querySelector('[data-jpc-field]');
  const fieldLabel = root.querySelector('[data-jpc-field-label]');
  const input = root.querySelector('[data-jpc-input]');
  const nextButton = root.querySelector('[data-jpc-next]');
  const backButton = root.querySelector('[data-jpc-back]');
  const progress = root.querySelector('[data-jpc-progress]');
  const nativeForm = document.getElementById('JSPrivateClientConciergeNativeForm');

  const metadata = {
    shopName: root.dataset.shopName || '',
    pageTitle: root.dataset.pageTitle || document.title,
    pageUrl: root.dataset.pageUrl || window.location.href,
    template: root.dataset.template || '',
    ownerEmail: root.dataset.ownerEmail || 'jasjeetsinghrealty@gmail.com',
    automationVersion: '2026-06-23.full-router.1'
  };

  const CONSENT_QUESTION = {
    key: 'follow_up_permission',
    type: 'choice',
    prompt: 'How should Jasjeet follow up?',
    options: ['Email and text are okay', 'Email only', 'Phone/text only']
  };

  const FLOW_MAP = {
    buyer: {
      label: 'Buy',
      leadSource: 'JS Website — Buyer',
      campaign: 'Buyer Consultation',
      taskTitle: 'Call new buyer lead',
      intro: 'Perfect. I’ll collect the key buyer details so Jasjeet can respond with a clear search and strategy path.',
      done: 'Your buyer request has been received. Jasjeet will review your preferred area, budget and timing, then follow up with a clear search plan.',
      questions: [
        { key: 'preferred_area', type: 'choice', prompt: 'Where are you looking?', options: ['Calgary', 'Airdrie', 'Chestermere', 'Cochrane', 'Still exploring'] },
        { key: 'property_type', type: 'choice', prompt: 'What type of property?', options: ['Detached', 'Townhome', 'Condo', 'Luxury home', 'Not sure yet'] },
        { key: 'budget', type: 'choice', prompt: 'Approximate budget?', options: ['Under $500K', '$500K–$750K', '$750K–$1M', '$1M–$1.5M', '$1.5M+'] },
        { key: 'timeline', type: 'choice', prompt: 'When would you like to buy?', options: ['Immediately', '1–3 months', '3–6 months', '6+ months', 'Just researching'] },
        { key: 'financing', type: 'choice', prompt: 'Financing status?', options: ['Pre-approved', 'Need mortgage guidance', 'Cash purchase', 'Not started'] },
        { key: 'notes', type: 'text', prompt: 'Anything important Jasjeet should know?', label: 'Needs, communities, must-haves', optional: true },
        { key: 'name', type: 'text', prompt: 'What is your name?', label: 'Full name', autocomplete: 'name' },
        { key: 'email', type: 'email', prompt: 'Best email for follow-up?', label: 'Email address', autocomplete: 'email' },
        { key: 'phone', type: 'tel', prompt: 'Best phone number?', label: 'Phone number', autocomplete: 'tel' },
        CONSENT_QUESTION
      ]
    },
    seller: {
      label: 'Sell',
      leadSource: 'JS Website — Seller',
      campaign: 'Seller Strategy',
      taskTitle: 'Call new seller lead',
      intro: 'Great. I’ll prepare the essentials for a private selling strategy conversation.',
      done: 'Your seller request has been received. Jasjeet will review your property details, timing and priorities, then follow up about pricing and preparation.',
      questions: [
        { key: 'property_area', type: 'text', prompt: 'Where is the property located?', label: 'City or community' },
        { key: 'property_type', type: 'choice', prompt: 'What type of home?', options: ['Detached', 'Townhome', 'Condo', 'Acreage', 'Luxury property'] },
        { key: 'timeline', type: 'choice', prompt: 'When are you considering selling?', options: ['Immediately', '1–3 months', '3–6 months', '6+ months', 'Exploring value'] },
        { key: 'priority', type: 'choice', prompt: 'Main selling priority?', options: ['Max price', 'Discretion/private sale', 'Fast sale', 'Upsizing', 'Downsizing'] },
        { key: 'property_notes', type: 'text', prompt: 'Any upgrades or important details?', label: 'Upgrades, condition, special features', optional: true },
        { key: 'name', type: 'text', prompt: 'What is your name?', label: 'Full name', autocomplete: 'name' },
        { key: 'email', type: 'email', prompt: 'Best email for follow-up?', label: 'Email address', autocomplete: 'email' },
        { key: 'phone', type: 'tel', prompt: 'Best phone number?', label: 'Phone number', autocomplete: 'tel' },
        CONSENT_QUESTION
      ]
    },
    valuation: {
      label: 'Home value',
      leadSource: 'JS Website — Home Valuation',
      campaign: 'Home Valuation',
      taskTitle: 'Prepare valuation follow-up',
      intro: 'Absolutely. This will not generate a fake automated value. It will collect the details needed for a real valuation review.',
      done: 'Your home valuation request has been received. Jasjeet will review the property details and relevant comparable sales before following up.',
      questions: [
        { key: 'property_address', type: 'text', prompt: 'What is the property address?', label: 'Address or nearest major intersection' },
        { key: 'property_type', type: 'choice', prompt: 'What type of property?', options: ['Detached', 'Townhome', 'Condo', 'Acreage', 'Other'] },
        { key: 'bed_bath', type: 'text', prompt: 'Bedrooms and bathrooms?', label: 'Example: 4 bed, 3 bath' },
        { key: 'timeline', type: 'choice', prompt: 'Why do you want the value?', options: ['Thinking of selling', 'Refinancing', 'Curious', 'Estate/family planning', 'Buying another home'] },
        { key: 'upgrades', type: 'text', prompt: 'Any upgrades or renovations?', label: 'Kitchen, basement, exterior, mechanicals', optional: true },
        { key: 'name', type: 'text', prompt: 'What is your name?', label: 'Full name', autocomplete: 'name' },
        { key: 'email', type: 'email', prompt: 'Best email for follow-up?', label: 'Email address', autocomplete: 'email' },
        { key: 'phone', type: 'tel', prompt: 'Best phone number?', label: 'Phone number', autocomplete: 'tel' },
        CONSENT_QUESTION
      ]
    },
    relocation: {
      label: 'Relocate',
      leadSource: 'JS Website — Relocation',
      campaign: 'Relocation Consultation',
      taskTitle: 'Call new relocation lead',
      intro: 'Good choice. I’ll collect your relocation details so Jasjeet can narrow the right areas and next steps.',
      done: 'Your relocation request has been received. Jasjeet will review your timing, preferred areas and lifestyle needs before following up.',
      questions: [
        { key: 'moving_from', type: 'text', prompt: 'Where are you moving from?', label: 'Current city/province/country' },
        { key: 'target_area', type: 'choice', prompt: 'Where are you considering?', options: ['Calgary', 'Airdrie', 'Chestermere', 'Cochrane', 'Open to guidance'] },
        { key: 'timeline', type: 'choice', prompt: 'Relocation timeline?', options: ['Immediately', '1–3 months', '3–6 months', '6+ months', 'Researching'] },
        { key: 'lifestyle', type: 'choice', prompt: 'What matters most?', options: ['Schools', 'Commute', 'Luxury living', 'Family space', 'Budget/value'] },
        { key: 'budget', type: 'choice', prompt: 'Approximate budget?', options: ['Under $500K', '$500K–$750K', '$750K–$1M', '$1M–$1.5M', '$1.5M+'] },
        { key: 'notes', type: 'text', prompt: 'Anything else about the move?', label: 'Family needs, work location, timing', optional: true },
        { key: 'name', type: 'text', prompt: 'What is your name?', label: 'Full name', autocomplete: 'name' },
        { key: 'email', type: 'email', prompt: 'Best email for follow-up?', label: 'Email address', autocomplete: 'email' },
        { key: 'phone', type: 'tel', prompt: 'Best phone number?', label: 'Phone number', autocomplete: 'tel' },
        CONSENT_QUESTION
      ]
    },
    contact: {
      label: 'Contact',
      leadSource: 'JS Website — Contact',
      campaign: 'General Inquiry',
      taskTitle: 'Reply to website inquiry',
      intro: 'Of course. I’ll route your message clearly so Jasjeet knows exactly what you need.',
      done: 'Your message has been received. Jasjeet will review your request and contact details before responding.',
      questions: [
        { key: 'reason', type: 'choice', prompt: 'What do you need help with?', options: ['Buying', 'Selling', 'Home value', 'Relocation', 'General question'] },
        { key: 'message', type: 'text', prompt: 'What should Jasjeet know?', label: 'Your message' },
        { key: 'name', type: 'text', prompt: 'What is your name?', label: 'Full name', autocomplete: 'name' },
        { key: 'email', type: 'email', prompt: 'Best email for follow-up?', label: 'Email address', autocomplete: 'email' },
        { key: 'phone', type: 'tel', prompt: 'Best phone number?', label: 'Phone number', autocomplete: 'tel' },
        CONSENT_QUESTION
      ]
    }
  };

  const state = {
    open: false,
    flowKey: null,
    step: 0,
    answers: {},
    isSubmitting: false
  };

  const startOptions = [
    { key: 'buyer', label: 'Buy a home' },
    { key: 'seller', label: 'Sell a home' },
    { key: 'valuation', label: 'Home value' },
    { key: 'relocation', label: 'Relocation' },
    { key: 'contact', label: 'Contact Jasjeet' }
  ];

  const escapeText = (value) => String(value || '').replace(/[&<>'"]/g, (character) => ({
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    "'": '&#039;',
    '"': '&quot;'
  }[character]));

  const getOrCreateVisitorId = () => {
    const key = 'jpc_visitor_id';
    try {
      let id = window.localStorage.getItem(key);
      if (!id) {
        id = `jpc_${Date.now()}_${Math.random().toString(36).slice(2, 10)}`;
        window.localStorage.setItem(key, id);
      }
      return id;
    } catch (error) {
      return `jpc_${Date.now()}`;
    }
  };

  const addMessage = (message, role = 'assistant') => {
    const bubble = document.createElement('div');
    bubble.className = `jpc-message${role === 'user' ? ' jpc-message--user' : ''}`;
    bubble.innerHTML = escapeText(message);
    thread.appendChild(bubble);
    const body = root.querySelector('[data-jpc-body]');
    if (body) body.scrollTop = body.scrollHeight;
  };

  const clearComposer = () => {
    question.textContent = '';
    options.innerHTML = '';
    field.hidden = true;
    input.value = '';
    input.removeAttribute('type');
    input.removeAttribute('autocomplete');
    input.removeAttribute('aria-invalid');
    nextButton.hidden = true;
    backButton.hidden = true;
  };

  const setProgress = () => {
    if (!progress) return;
    if (!state.flowKey) {
      progress.style.width = '0%';
      return;
    }
    const flow = FLOW_MAP[state.flowKey];
    const percent = Math.min(100, Math.round((state.step / flow.questions.length) * 100));
    progress.style.width = `${percent}%`;
  };

  const showStart = () => {
    state.flowKey = null;
    state.step = 0;
    state.answers = {};
    state.isSubmitting = false;
    thread.innerHTML = '';
    clearComposer();
    setProgress();
    addMessage('Welcome. What would you like help with today?');
    question.textContent = 'Choose your path';
    startOptions.forEach((item) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'jpc-option';
      button.textContent = item.label;
      button.addEventListener('click', () => startFlow(item.key));
      options.appendChild(button);
    });
  };

  const startFlow = (flowKey) => {
    const flow = FLOW_MAP[flowKey];
    if (!flow) return;
    state.flowKey = flowKey;
    state.step = 0;
    state.answers = {};
    thread.innerHTML = '';
    addMessage(flow.intro);
    renderStep();
  };

  const renderStep = () => {
    const flow = FLOW_MAP[state.flowKey];
    const current = flow.questions[state.step];
    clearComposer();
    setProgress();

    if (!current) {
      submitLead();
      return;
    }

    question.textContent = current.prompt;
    backButton.hidden = state.step === 0;

    if (current.type === 'choice') {
      current.options.forEach((label) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'jpc-option';
        button.textContent = label;
        button.addEventListener('click', () => {
          state.answers[current.key] = label;
          addMessage(label, 'user');
          state.step += 1;
          renderStep();
        });
        options.appendChild(button);
      });
      return;
    }

    field.hidden = false;
    fieldLabel.textContent = current.label || current.prompt;
    input.type = current.type === 'email' ? 'email' : current.type === 'tel' ? 'tel' : 'text';
    input.placeholder = current.optional ? 'Optional' : '';
    input.autocomplete = current.autocomplete || 'off';
    input.value = state.answers[current.key] || '';
    nextButton.hidden = false;
    window.requestAnimationFrame(() => input.focus({ preventScroll: true }));
  };

  const validateCurrent = () => {
    const flow = FLOW_MAP[state.flowKey];
    const current = flow.questions[state.step];
    if (!current || current.type === 'choice') return true;
    const value = input.value.trim();

    if (!value && current.optional) {
      state.answers[current.key] = '';
      return true;
    }

    if (!value) {
      input.focus();
      input.setAttribute('aria-invalid', 'true');
      return false;
    }

    if (current.type === 'email' && !/^\S+@\S+\.\S+$/.test(value)) {
      input.focus();
      input.setAttribute('aria-invalid', 'true');
      return false;
    }

    input.removeAttribute('aria-invalid');
    state.answers[current.key] = value;
    addMessage(value, 'user');
    return true;
  };

  const getUtm = () => {
    const params = new URLSearchParams(window.location.search);
    const keys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'gclid', 'fbclid'];
    return keys.reduce((accumulator, key) => {
      if (params.has(key)) accumulator[key] = params.get(key);
      return accumulator;
    }, {});
  };

  const scoreLead = (flowKey, answers) => {
    let score = 35;
    const urgency = String(answers.timeline || '').toLowerCase();
    const budget = String(answers.budget || '').toLowerCase();
    const financing = String(answers.financing || '').toLowerCase();
    const priority = String(answers.priority || '').toLowerCase();

    if (flowKey === 'valuation' || flowKey === 'seller') score += 15;
    if (urgency.includes('immediately')) score += 30;
    if (urgency.includes('1–3') || urgency.includes('1-3')) score += 20;
    if (budget.includes('$1m') || budget.includes('$1.5m')) score += 15;
    if (financing.includes('pre-approved') || financing.includes('cash')) score += 12;
    if (priority.includes('max price') || priority.includes('discretion')) score += 8;
    if (answers.phone) score += 5;
    if (answers.email) score += 5;

    return Math.max(0, Math.min(100, score));
  };

  const getRouting = (flowKey, answers) => {
    const flow = FLOW_MAP[flowKey];
    const score = scoreLead(flowKey, answers);
    const hot = score >= 75;
    const now = new Date();
    const due = new Date(now.getTime() + (hot ? 5 : 60) * 60 * 1000);

    return {
      crm: 'BoldTrail',
      lead_status: hot ? 'Hot website lead' : 'New website lead',
      lead_score: score,
      priority: hot ? 'High' : 'Normal',
      assigned_to: 'Jasjeet Singh',
      source: flow.leadSource,
      tags: [flow.leadSource, 'JS Website', 'JS Private Client Concierge', `Lead Type — ${flow.label}`, hot ? 'Priority — High' : 'Priority — Normal'],
      campaign: flow.campaign,
      task: {
        title: flow.taskTitle,
        due_in_minutes: hot ? 5 : 60,
        due_at: due.toISOString()
      }
    };
  };

  const buildBody = (payload) => {
    const lines = [
      'JS PRIVATE CLIENT CONCIERGE LEAD',
      '',
      `Lead source: ${payload.lead_source}`,
      `Lead type: ${payload.lead_type}`,
      `Lead score: ${payload.routing.lead_score}`,
      `Priority: ${payload.routing.priority}`,
      `Campaign: ${payload.routing.campaign}`,
      `Task: ${payload.routing.task.title}`,
      `Name: ${payload.name}`,
      `Email: ${payload.email}`,
      `Phone: ${payload.phone}`,
      `Follow-up permission: ${payload.follow_up_permission}`,
      `Page: ${payload.page_url}`,
      `Submitted at: ${payload.submitted_at}`,
      '',
      'INTAKE DETAILS:'
    ];

    Object.entries(payload.answers).forEach(([key, value]) => {
      if (value) lines.push(`${key.replace(/_/g, ' ')}: ${value}`);
    });

    lines.push('', 'ROUTING:', `BoldTrail tag/source: ${payload.lead_source}`);
    payload.routing.tags.forEach((tag) => lines.push(`Tag: ${tag}`));
    lines.push('', 'Note: This website automation does not claim live MLS, IDX, or instant valuation access.');
    return lines.join('\n');
  };

  const buildPayload = () => {
    const flow = FLOW_MAP[state.flowKey];
    const answers = { ...state.answers };
    const name = answers.name || '';
    const email = answers.email || '';
    const phone = answers.phone || '';
    const submittedAt = new Date().toISOString();
    const routing = getRouting(state.flowKey, answers);
    const firstName = name.trim().split(/\s+/)[0] || '';
    const lastName = name.trim().split(/\s+/).slice(1).join(' ') || '';

    const payload = {
      automation_version: metadata.automationVersion,
      lead_source: flow.leadSource,
      lead_type: state.flowKey,
      lead_label: flow.label,
      name,
      first_name: firstName,
      last_name: lastName,
      email,
      phone,
      follow_up_permission: answers.follow_up_permission || '',
      message: answers.message || answers.notes || answers.property_notes || '',
      summary: '',
      answers,
      routing,
      crm_tags: routing.tags,
      lead_score: routing.lead_score,
      page_url: window.location.href,
      canonical_url: metadata.pageUrl,
      page_title: metadata.pageTitle,
      template: metadata.template,
      referrer: document.referrer || '',
      submitted_at: submittedAt,
      visitor_id: getOrCreateVisitorId(),
      user_agent: window.navigator.userAgent || '',
      utm: getUtm()
    };

    payload.summary = buildBody(payload);
    payload.notifications = {
      email_subject: `New ${flow.label} lead from JS website — ${name || 'Unknown'}`,
      lead_confirmation_subject: `We received your ${flow.label.toLowerCase()} request`,
      internal_alert: `${payload.routing.priority} ${flow.label} lead: ${name || 'Unknown'} | ${phone || email || 'No contact'} | Score ${payload.routing.lead_score}`
    };

    return payload;
  };

  const fillNativeForm = (payload) => {
    if (!nativeForm) return null;
    const fields = {
      name: payload.name,
      email: payload.email,
      phone: payload.phone,
      lead_source: payload.lead_source,
      lead_type: payload.lead_type,
      request_type: `${payload.lead_label} concierge request`,
      consent: payload.follow_up_permission,
      crm_tags: payload.crm_tags.join(', '),
      page_url: payload.page_url,
      submitted_at: payload.submitted_at,
      body: payload.summary
    };

    Object.entries(fields).forEach(([key, value]) => {
      const node = nativeForm.querySelector(`[data-jpc-native="${key}"]`);
      if (node) node.value = value || '';
    });

    return new FormData(nativeForm);
  };

  const postWebhook = async (payload) => {
    const webhook = (root.dataset.webhook || '').trim();
    if (!webhook) return { skipped: true };

    const response = await fetch(webhook, {
      method: 'POST',
      headers: { 'Content-Type': 'text/plain;charset=UTF-8' },
      body: JSON.stringify(payload),
      keepalive: true
    });

    if (!response.ok) throw new Error(`Webhook rejected lead with ${response.status}`);
    return { ok: true };
  };

  const postNativeForm = async (payload) => {
    const formData = fillNativeForm(payload);
    if (!nativeForm || !formData) return { skipped: true };
    const action = (nativeForm.getAttribute('action') || '/contact').split('#')[0];
    const response = await fetch(action, {
      method: 'POST',
      body: formData,
      credentials: 'same-origin'
    });

    if (!response.ok) throw new Error(`Shopify contact form rejected lead with ${response.status}`);
    return { ok: true };
  };

  const submitLead = async () => {
    if (state.isSubmitting) return;
    state.isSubmitting = true;
    clearComposer();
    setProgress();
    progress.style.width = '100%';
    addMessage('Preparing your request now.');

    const flow = FLOW_MAP[state.flowKey];
    const payload = buildPayload();
    let webhookOk = false;
    let nativeOk = false;
    const hasWebhook = Boolean((root.dataset.webhook || '').trim());

    try {
      const result = await postWebhook(payload);
      webhookOk = Boolean(result.ok || result.skipped);
    } catch (error) {
      console.warn('[JS Private Client Concierge] Webhook submission failed:', error);
    }

    if (!hasWebhook || !webhookOk) {
      try {
        const result = await postNativeForm(payload);
        nativeOk = Boolean(result.ok || result.skipped);
      } catch (error) {
        console.warn('[JS Private Client Concierge] Shopify contact fallback failed:', error);
      }
    }

    thread.innerHTML = '';

    if (webhookOk || nativeOk) {
      addMessage(`Thank you — ${flow.done}`);
      question.textContent = 'Request sent';
      options.innerHTML = '';
      const again = document.createElement('button');
      again.type = 'button';
      again.className = 'jpc-option';
      again.textContent = 'Start another request';
      again.addEventListener('click', showStart);
      options.appendChild(again);
      return;
    }

    addMessage(`I could not submit this automatically. Please email ${metadata.ownerEmail} or call/text Jasjeet directly, and include the details you entered here.`);
    question.textContent = 'Manual follow-up needed';
    const retry = document.createElement('button');
    retry.type = 'button';
    retry.className = 'jpc-option';
    retry.textContent = 'Try again';
    retry.addEventListener('click', submitLead);
    options.appendChild(retry);
    state.isSubmitting = false;
  };

  let lastFocusedElement = null;

  const panelFocusableElements = () => Array.from(panel.querySelectorAll(
    'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
  )).filter((element) => !element.hidden && element.getAttribute('aria-hidden') !== 'true' && element.getClientRects().length > 0);

  const openPanel = (flowKey) => {
    lastFocusedElement = document.activeElement;
    state.open = true;
    panel.hidden = false;
    openButton.setAttribute('aria-expanded', 'true');
    document.documentElement.classList.add('jpc-is-open');
    const mobile = window.matchMedia('(max-width: 749px)').matches;
    panel.setAttribute('aria-modal', mobile ? 'true' : 'false');
    document.body.classList.toggle('jpc-mobile-open', mobile);

    if (flowKey && FLOW_MAP[flowKey]) {
      startFlow(flowKey);
    } else if (!state.flowKey && thread.children.length === 0) {
      showStart();
    }

    window.setTimeout(() => {
      const focusable = panelFocusableElements();
      if (focusable.length) focusable[0].focus({ preventScroll: true });
    }, 50);
  };

  const closePanel = () => {
    state.open = false;
    panel.hidden = true;
    openButton.setAttribute('aria-expanded', 'false');
    document.documentElement.classList.remove('jpc-is-open');
    document.body.classList.remove('jpc-mobile-open');
    panel.setAttribute('aria-modal', 'false');
    const focusTarget = lastFocusedElement && typeof lastFocusedElement.focus === 'function' ? lastFocusedElement : openButton;
    focusTarget.focus({ preventScroll: true });
    lastFocusedElement = null;
  };

  openButton.addEventListener('click', () => {
    if (state.open) closePanel();
    else openPanel();
  });

  closeButton.addEventListener('click', closePanel);

  document.addEventListener('keydown', (event) => {
    if (!state.open) return;
    if (event.key === 'Escape') {
      closePanel();
      return;
    }
    if (event.key !== 'Tab') return;
    const focusable = panelFocusableElements();
    if (!focusable.length) return;
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-jpc-trigger]');
    if (!trigger) return;
    event.preventDefault();
    openPanel(trigger.dataset.jpcTrigger || null);
  });

  form.addEventListener('submit', (event) => {
    event.preventDefault();
    if (!state.flowKey) return;
    if (!validateCurrent()) return;
    state.step += 1;
    renderStep();
  });

  backButton.addEventListener('click', () => {
    if (!state.flowKey || state.step <= 0) return;
    state.step -= 1;
    renderStep();
  });

  const urlParams = new URLSearchParams(window.location.search);
  const requestedFlow = urlParams.get('concierge');
  if (requestedFlow && FLOW_MAP[requestedFlow]) {
    window.requestAnimationFrame(() => openPanel(requestedFlow));
  }
})();
